module.exports = __webpack_public_path__ + "static/media/group.0a65fb4b.svg";